import { Step, StepLabel, Stepper, useMediaQuery } from '@material-ui/core'

const StatusProgressV2 = ({ ticket }) => {
  const { process_states, archived } = ticket
  let { step_rank } = ticket
  const isOnMobile = useMediaQuery('(max-width:500px)')
  // If it's archived I change the state to the lastone to show them as finished.
  if (archived) step_rank = process_states?.length
  let steps = []
  for (let k = 0; k < process_states?.length; k++) {
    steps.push({
      id: k,
      label: process_states[k],
    })
  }

  return (
    <Stepper
      activeStep={step_rank - 1}
      orientation={isOnMobile ? 'vertical' : 'horizontal'}
      alternativeLabel={!isOnMobile}
    >
      {steps.map((s) => (
        <Step key={s.id}>
          <StepLabel>{s.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
export default StatusProgressV2
